import React from 'react';
import { FILE_SIZE_MAX_MB, FILE_TYPES_ACCEPTED } from '../../utils/constants';

const FileUploadDescription = () => {
  const typeList = new Intl.ListFormat('en', { type: 'disjunction' }).format(
    FILE_TYPES_ACCEPTED,
  );
  return (
    <div className="vads-u-margin-bottom--4">
      <strong>What to know about uploading files</strong>
      <ul>
        <li>Upload 1 file at a time</li>
        <li>Use a {typeList} file</li>
        <li>
          Limit the file size to {FILE_SIZE_MAX_MB}
          <abbr title="Megabytes">MB</abbr> or less
        </li>
      </ul>
    </div>
  );
};

export default FileUploadDescription;
